/**
 * @enum {string}
 */
export const ModalType = {
  MANDATORY: 'mandatory',
  OTHER: 'other'
};